import type {AxiosInstance} from 'axios'
import {makeAxios} from './api/axiosApi/axiosAPI'

export const REST: AxiosInstance = await makeAxios()
